import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './login-form/login-form.component';
import { TranslocoModule } from '@ngneat/transloco';
import { FormFieldModule } from '../form-field/form-field.module';
import { ButtonModule } from '../button/button.module';
import { IconButtonModule } from '../icon-button/icon-button.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { PurifyModule } from '@thema-core/pipes';
import {
  IsEmailValidatorModule,
  MustMatchValidatorModule,
  PasswordValidatorModule,
} from '@thema-core/directives';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    FormFieldModule,
    ButtonModule,
    IconButtonModule,
    ReactiveFormsModule,
    FormsModule,
    CheckboxModule,
    MustMatchValidatorModule,
    RouterModule,
    PasswordValidatorModule,
    IsEmailValidatorModule,
    PurifyModule,
  ],
})
export class LoginFormModule {}
